import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from "react-native";
import { tMessageFile } from "tmt_api/src/types/types";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { formatFileSize } from "src/util/gFormatting";

import { PdFile, PdFileJpg, PdFilePdf, PdFilePng } from "src/components/Icons";
import { PdText } from "src/components/layout";
import React from "react";
import { tSvgProps } from "src/components/types";

const fileTypes: Record<string, { icon: React.FC<tSvgProps>; type: string }> = {
  "application/pdf": { icon: PdFilePdf, type: "PDF" },
  "image/jpeg": { icon: PdFileJpg, type: "JPG" },
  "image/png": { icon: PdFilePng, type: "PNG" },
  default: { icon: PdFile, type: "" },
};

const MessageFile: React.FC<{
  data: tMessageFile;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
}> = ({ data, onPress, style }) => {
  const fileType = fileTypes[data.type] || fileTypes.default;
  const FileIcon = fileType.icon;
  return (
    <TouchableOpacity style={[styles.messageFile, style]} onPress={onPress}>
      <View style={styles.messageFileIconContainer}>
        <FileIcon color={kColors.brandDark} style={styles.messageFileIcon} />
      </View>
      <View style={styles.flex1}>
        <PdText variant="body-sm" numberOfLines={1} style={styles.messageFileName}>
          {data.name}
        </PdText>
        <PdText variant="body-sm">{`${formatFileSize(data.size)} ${fileType.type}`}</PdText>
      </View>
    </TouchableOpacity>
  );
};

export default MessageFile;

const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  messageFile: {
    alignItems: "center",
    borderColor: kColors.grayPink,
    borderRadius: kStyleConst.kSpacing * 1.5,
    borderWidth: 1,
    flexDirection: "row",
    maxWidth: 200,
    paddingHorizontal: kStyleConst.kSpacing * 3,
    paddingVertical: kStyleConst.kSpacing * 2,
    width: "100%",
  },
  messageFileIcon: {
    height: 25,
  },
  messageFileIconContainer: {
    marginRight: kStyleConst.kSpacing * 2,
  },
  messageFileName: {
    fontWeight: "500",
  },
});
